var exports = {
  "k": "x804f0401--6a283d--container",
  "L": "x804f0401--6a283d--mobile-rating",
};

module.exports = exports;
